import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_FOOTER = {
	[LANGUAGE.en.short]: {
		haveAnIdea: 'Have an Idea for New Content? ',
		shareSuggestion: 'Share your suggestion with us through a quick, non-binding inquiry — it only takes a few minutes. Our GOP ' +
			'team will review your idea and follow up if needed.',
		sendSuggestion: 'Send Your Suggestion',
		needHelp: 'Need Help? We’re Here for You ',
		haveTrouble: 'Having trouble with the tool? Our team is ready to assist anytime. Just reach out via email —we’ll respond as soon as possible.',
		contactSupport: 'Contact Support',
		myCountry: 'My Country',
		all: 'All',
		localExpertise: 'Local Expertise',
		countryPortfolio: "Country Portfolio"
	},
	[LANGUAGE.de.short]: {
		haveAnIdea: 'Haben Sie eine Idee für neue Inhalte?',
		shareSuggestion: 'Teilen Sie uns Ihren Vorschlag durch eine kurze, unverbindliche Anfrage mit – es dauert nur wenige Minuten. Unser GOP-Team wird Ihre Idee prüfen und sich bei Bedarf melden.',
		sendSuggestion: 'Vorschlag senden',
		needHelp: 'Brauchen Sie Hilfe? Wir sind für Sie da',
		haveTrouble: 'Probleme mit dem Tool? Unser Team steht Ihnen jederzeit zur Verfügung. Schreiben Sie uns einfach eine E-Mail – wir antworten so schnell wie möglich.',
		contactSupport: 'Support kontaktieren',
		myCountry: 'Mein Land',
		all: 'Alle',
		localExpertise: 'Lokale Expertise',
		countryPortfolio: "Länderportfolio"
	},
	[LANGUAGE.fr.short]: {
		haveAnIdea: 'Vous avez une idée de nouveau contenu ?',
		shareSuggestion: 'Partagez votre suggestion avec nous via une demande rapide et sans engagement — cela ne prend que quelques minutes. Notre équipe GOP examinera votre idée et reviendra vers vous si nécessaire.',
		sendSuggestion: 'Envoyer votre suggestion',
		needHelp: 'Besoin d’aide ? Nous sommes là pour vous',
		haveTrouble: 'Vous rencontrez des difficultés avec l’outil ? Notre équipe est prête à vous aider à tout moment. Contactez-nous par e-mail — nous vous répondrons dès que possible.',
		contactSupport: 'Contacter le support',
		myCountry: 'Mon pays',
		all: 'Tous',
		localExpertise: 'Expertise locale',
		countryPortfolio: "Portefeuille pays"
	},
	[LANGUAGE.it.short]: {
		haveAnIdea: 'Hai un’idea per nuovi contenuti?',
		shareSuggestion: 'Condividi il tuo suggerimento con noi tramite una rapida richiesta non vincolante: richiedere solo pochi minuti. Il nostro team GOP esaminerà la tua idea e ti ricontatterà se necessario.',
		sendSuggestion: 'Invia il tuo suggerimento',
		needHelp: 'Serve aiuto? Siamo qui per te',
		haveTrouble: 'Hai problemi con lo strumento? Il nostro team è pronto ad assisterti in qualsiasi momento. Contattaci via e-mail: risponderemo il prima possibile.',
		contactSupport: 'Contatta il supporto',
		myCountry: 'Il mio Paese',
		all: 'Tutto',
		localExpertise: 'Competenza locale',
		countryPortfolio: "Portafoglio paesi"
	},
	[LANGUAGE.ja.short]: {
		haveAnIdea: '新しいコンテンツのアイデアをお持ちですか？',
		shareSuggestion: '簡単な内容確認（拘束力はありません）を通じて、あなたの提案を共有してください。わずか数分で完了します。当社のGOPチームがアイデアを検討し、必要に応じてご連絡いたします。',
		sendSuggestion: '提案を送信する',
		needHelp: 'お困りですか？サポートいたします',
		haveTrouble: 'ツールの使用でお困りですか？当社のチームがいつでもお手伝いします。メールでお問い合わせいただければ、できるだけ早く返信いたします。',
		contactSupport: 'サポートに連絡',
		myCountry: '私の国',
		all: 'すべて',
		localExpertise: '地域に根ざした専門知識',
		countryPortfolio: "国別ポートフォリオ"
	},
	[LANGUAGE.es.short]: {
		haveAnIdea: '¿Tienes una idea para contenido nuevo?',
		shareSuggestion: 'Comparte tu sugerencia con nosotros a través de una consulta rápida y no vinculante; solo te llevará unos minutos. Nuestro equipo de GOP revisará tu idea y se pondrá en contacto contigo si es necesario.',
		sendSuggestion: 'Enviar sugerencia',
		needHelp: '¿Necesitas ayuda? Estamos aquí para ti',
		haveTrouble: '¿Tienes problemas con la herramienta? Nuestro equipo está listo para ayudarte en cualquier momento. Solo contáctanos por correo electrónico; responderemos lo antes posible.',
		contactSupport: 'Contactar con soporte',
		myCountry: 'Mi país',
		all: 'Todo',
		localExpertise: 'Experiencia local',
		countryPortfolio: "Cartera de países"
	}
}
